module.exports = __webpack_public_path__ + "img/02.850b4df4.svg";